import LoadingComponent from "../../app/layout/LoadingComponent";
import { observer } from "mobx-react-lite";
import { Link } from "react-router-dom";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useStore } from "../../app/stores/store";
import agent from "../../app/api/agent";
import SimpleFileUploadForm from "./handlers/ImagenInstitucional";

import Container from "react-bootstrap/Container";
import { Button } from 'semantic-ui-react'
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

import { Image } from "semantic-ui-react";

import Footer from "../Footer";

import "./src/pInstitucional.css";
import escudoGuate from "./src/img/escudo_guatemala_fondo.png";
import logoEje from "./src/img/logo-institucion-placeholder.png";

import cardSolicitud from "./src/img/solicitud.png";
import cardConvenio from "./src/img/convenios.png";
import DetalleConvenios from "../Convenios/DetalleConvenios";

export default observer(function DetalleConvenioInstitucional() {
  
  const [modalShow, setModalShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const { userStore: { user, roles } } = useStore();
  const [entidad, setEntidad] = useState();
  const [entidadId, setEntidadId] = useState();
  const [imgp, setImgp] = useState<any>(null);

  let datain: any;
  let datast: any;
  
  const getDetallePerfil = async () => {
    setLoading(true);

    const perfilAPI = process.env.REACT_APP_API_URL + `/AccountsManager/GetEntityByUser/${user?.id}`;
    const resp = await fetch(perfilAPI);
    datain = await resp.json();
    let enti = datain.entidad;
    let entiID = datain.idEntidad;
    
    const perfilImg = process.env.REACT_APP_API_URL + `/Storage/${entiID}/${"SGTEntidad"}`;
    const r = await fetch(perfilImg);
    datast = await r.json();
    const ultima = datast.length -1;
  
    setImgp(datast[ultima]?.fileName);
    setEntidad(enti);
    setEntidadId(entiID);
    
    setLoading(false);
  }; useEffect(() => { getDetallePerfil() }, [ entidad, entidadId, imgp ]);

  return (
    <>

    {entidad ?
    
      <>
        <Container fluid className="header-institu">
          <Container fluid className="back-head"></Container>

          <Container className="content-head">
            <Row>
              <Col xs={5}>
                <Image src={escudoGuate} />
                <div className="logo-area">
                  <Image src={`${process.env.REACT_APP_FILEPATH_PIN_IMG_URL}/${imgp}`} />
                </div>
              </Col>
              <Col xs={7}>
                <p>Perfil Institucional -</p>
                <h2>{entidad}</h2>
              </Col>
            </Row>
            
          </Container>
        </Container>

        <Container className="content-institu">
     
            <DetalleConvenios />
     
        </Container>
      </>
      
      : 
      
      <>
        <Container className="institucion-alerta">
          <Row>
            <div className="institucion-alerta-contenido"><p>El usuario con el que te encuentras navegando en el portal, no cuenta con una institucion asignada, si consideras que deberias tener acceso al área institucional, por favor contacta a DITECI</p></div>
          </Row>
        </Container>

      </>
      
      }

      <Footer />

        <SimpleFileUploadForm 
          onHide={() => { setModalShow(false) }}
          show={modalShow}
          pinst={entidadId}
          ctype={"SGTEntidad"}

        />

    </>
  );

  
})